import * as React from 'react';
const SvgFsharp = props => (
  <svg xmlns='http://www.w3.org/2000/svg' width={800} height={800} viewBox='0 0 32 32' {...props}>
    <path
      d='M2 16 15.288 2.712v6.644L8.644 16l6.644 6.644v6.644Z'
      style={{
        fill: '#378bba',
      }}
    />
    <path
      d='m10.542 16 4.746-4.746v9.492Z'
      style={{
        fill: '#378bba',
      }}
    />
    <path
      d='M30 16 16.237 2.712v6.644L22.881 16l-6.644 6.644v6.644Z'
      style={{
        fill: '#30b9db',
      }}
    />
  </svg>
);
export default SvgFsharp;
